import React from 'react';

interface LazyWidgetProps {
  children: React.ReactNode;
  placeholder?: React.ReactNode;
  rootMargin?: string;
}

const LazyWidget: React.FC<LazyWidgetProps> = ({
  children,
  placeholder = null,
  rootMargin = '200px 0px',
}) => {
  const [isVisible, setIsVisible] = React.useState(false);
  const containerRef = React.useRef<HTMLDivElement | null>(null);

  React.useEffect(() => {
    if (isVisible) return undefined;

    if (typeof window === 'undefined' || typeof IntersectionObserver === 'undefined') {
      setIsVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry?.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin }
    );

    const node = containerRef.current;
    if (node) {
      observer.observe(node);
    }

    return () => observer.disconnect();
  }, [isVisible, rootMargin]);

  return (
    <div ref={containerRef} className="h-full w-full">
      {isVisible ? children : placeholder}
    </div>
  );
};

export default LazyWidget;
